import React, { useEffect, useRef } from "react";
import * as Chartist from "chartist";

function Chart(props) {
  const dom_element = useRef(null);
  const { id, className, type, data, options, responsiveOptions } = props;

  useEffect(() => {
    new Chartist[type](dom_element.current, data, options, responsiveOptions);
  });

  return <div ref={dom_element} className={className} id={id}></div>;
}
export default Chart;